/* ========================================================================
* DOM-based Routing
* Based on http://goo.gl/EUTi53 by Paul Irish
*
* Only fires on body classes that match. If a body class contains a dash,
* replace the dash with an underscore when adding it to the object below.
*
* .noConflict()
* The routing is enclosed within an anonymous function so that you can
* always reference jQuery with $, even when in .noConflict() mode.
* ======================================================================== */

(function($) {



    jQuery.fn.extend({
        affix: function(p) {
            var _t = this;
            _t.affixOff();
            var $window = jQuery(window);
            var params = {
                offset: 0,
                offsetBottom: 0,
                offsetTop: 0
            };
            jQuery(_t).data({affix:params});
            jQuery.extend(params, p);

            jQuery(_t).data().affix.func = function () {
                jQuery(_t).each(function () {
                    var params = jQuery(this).data().affix;
                    var $cart = jQuery(this);
                    if($cart.outerHeight() < $cart.parent().innerHeight() && $cart.outerHeight() < $window.innerHeight()*0.8) {

                        $cart.css({
                            "top": ($window.scrollTop()-$cart.parent().offset().top+params.offset) + "px",
                            "position": "absolute"
                        })
                        .parent()
                        .css("position", "relative");

                        var c = {
                            top: $cart.position().top,
                            bottom: $cart.parent().innerHeight() - ($cart.position().top + $cart.outerHeight()),
                            height: $cart.outerHeight(),
                            parentHeight: $cart.parent().innerHeight()
                        };

                        if(c.top < params.offsetTop || c.height > $window.height()*0.8) {
                            $cart.css("top", params.offsetTop + "px");
                        }
                        if(c.bottom < params.offsetBottom) {
                            $cart.css("top", (c.parentHeight - c.height - params.offsetBottom) + "px");
                        }
                    }
                    else {
                        $cart.css({
                            "position": "relative",
                            "top": params.offsetTop
                        });
                    }
                });
                $window.data({lastTop: $window.scrollTop()});
            };
            $window.on('scroll.affix-'+_t.uniqueId().attr('id'), jQuery(_t).data().affix.func).trigger('scroll.affix-'+_t.uniqueId().attr('id'));
            return this;
        },
        validatePhone: function(args, callback) {
            var response = -1;
            // response: -1 error
            // response: 0 invalid prefix
            // response: 1 prefix found
            // response: 2 success
            // response: 3 phone number too long
            // response: 4 phone number too short
            // response: 5 empty
            var prefixes = {
                "370": 11
            };
            jQuery.extend(prefixes, args);
            jQuery.extend(prefixes, this.data().prefixes);
            this.each(function () {
                var $this = jQuery(this);
                var value = $this.val();
                value = value.replace(/(?!^\+)\D+/g, "");
                $this.val(value);

                // length validation
                var keys = Object.keys(prefixes);
                keys.every(function (key) {
                    var len = prefixes[key];
                    error = [];
                    var code = 0;


                    var patt = new RegExp("^"+key.replace(/[-\/\\^$*+?.()|[\]{}]/g, '\\$&'), "g");
                    var res = patt.test(value);

                    if(res) {
                        code = 1;
                    }
                    if(code === 1 && value.length === len) {
                        code = 2;
                    }
                    if(code === 1 && value.length > len) {
                        code = 3;
                    }
                    if(code === 1 && value.length < len) {
                        code = 4;
                    }
                    if(!value.length) {
                        code = 5;
                    }
                    response = code;


                    if(code !== 0) {
                        return false;
                    }
                    return true;
                });
            });
            callback.apply(this, [response]);
        },
        affixOff: function () {
            var _t = this;
            var $window = jQuery(window);
            $window.off('scroll.affix-'+_t.uniqueId().attr('id'));
            _t.data().affix = null;
            jQuery(_t).each(function () {
                $(this).css({
                    'top': '',
                    'position': ''
                });
            });
        },

        selectRange: function(start, end) {
            if(end === undefined) {
                end = start;
            }
            return this.each(function() {
                if('selectionStart' in this) {
                    this.selectionStart = start;
                    this.selectionEnd = end;
                } else if(this.setSelectionRange) {
                    this.setSelectionRange(start, end);
                } else if(this.createTextRange) {
                    var range = this.createTextRange();
                    range.collapse(true);
                    range.moveEnd('character', end);
                    range.moveStart('character', start);
                    range.select();
                }
            });
        }
    });
    // Use this variable to set up the common and page specific functions. If you
    // rename this variable, you will also need to rename the namespace below.
    var Sage = {
        // All pages
        'common': {
            init: function() {
                // JavaScript to be fired on all pages

                // MODAL BLOCK scroll
                //
                $(window).on('scroll', function (e) {
                    if($('body').is('.modal-open')) {
                        $(window).scrollTop(window._ksLastScroll);
                    }
                    else {
                        window._ksLastScroll = $(window).scrollTop();
                    }
                }).on('touchmove', function (e) {
                    $(window).trigger('scroll');
                });


                $('#wpcf7-f365-p256-o1, #wpcf7-f365-p410-o1').on('wpcf7:invalid wpcf7:spam wpcf7:mailsent wpcf7:mailfailed', function (e, data) {
                    var $modal = $('<div></div>').addClass('modal fade wpcf7-modal');
                    var $modal_dialog = $('<div></div>').addClass('modal-dialog center');
                    var $modal_content = $('<div></div>').addClass('modal-content');
                    var $modal_body = $('<div></div>').addClass('modal-body');
                    var $modal_message = $('<span></span>').addClass('message').html(data.message);
                    var $modal_button = $('<span data-dismiss="modal"></span>').html(ks_strings.close).addClass('btn btn-primary');
                    var $modal_close = $('<button type="button" class="close wcp_close_modal" data-dismiss="modal" aria-label="Close"><i class="ks-icon close-icon"></i></button>');
                    $modal.append($modal_dialog.append($modal_content.append($modal_body.append($modal_message, $modal_button), $modal_close)));
                    $modal.modal('show');
                    $(this).find('.wpcf7-submit').removeClass('loading').prop('disabled', false);
                }).on('wpcf7:beforesubmit', function (e, detail) {
                    var $submit = $(this).find('.wpcf7-submit');
                    if($submit.prop('disabled')) {
                        throw("Hold on");
                    }
                    $submit.addClass('loading').prop('disabled', true);
                });


                // Search
                $(window).on('load', function () {

                    $('body').removeClass('loading');
                    var $search_block = $('header .search-block');
                    var $search_results = $search_block.find('.results');
                    $('header .search').on('click', function () {
                        $search_block.toggle();
                        $('header').toggleClass('search-open');
                    });
                    $search_block.find('.search-input').on('keyup change', function () {
                        var $this = $(this);
                        clearTimeout($this.data().inputTimeOut);
                        if($this.val().length > 3) {
                            $this.data().inputTimeOut = setTimeout(function () {
                                $.ajax({
                                    type: "POST",
                                    url: woocommerce_params.ajax_url+'?action='+"ks_search",
                                    data: {input: $this.val()}
                                }).done(function (response) {
                                    response = JSON.parse(response);
                                    $search_results.empty();
                                    $.each(response, function (label_key, label_value) {
                                        var $group = $('<ul></ul>');

                                        $.each(label_value, function (link_key, link_value) {
                                            var $a = $('<a></a>')
                                            .attr('href', link_value.url)
                                            .html(link_value.title);
                                            var $li = $('<li></li>').append($a);
                                            $group.append($li);
                                        });


                                        $search_results.append($('<li></li>').append($('<h4></h4>').html(label_key), $group));


                                    });
                                });
                            }, 400);
                        }
                    });

                    var search_tags = decodeURI(window.location.hash.replace(/\+|#/g, ' ')).split(' ');
                    var rows = [];

                    $.each(search_tags, function (k, v) {
                        if(v.length === 0) {
                            return;
                        }
                        $('*', '.row')
                        .andSelf()
                        .contents()
                        .filter(function(){
                            return this.nodeType === 3;
                        })
                        .filter(function(){
                            // Only match when contains 'simple string' anywhere in the text
                            return this.nodeValue.latinise().toLowerCase().indexOf(v.latinize().toLowerCase()) !== -1;
                        })
                        .each(function(i) {
                            if(i > 3) {
                                return;
                            }
                            // Do something with this.nodeValu
                            var $this = $(this.parentElement);
                            var $row = $this.closest('.row');
                            var row = $row[0];
                            var score = 1;

                            $.each(ks_search_scores, function (k, v) {
                                if($this.closest(v.selector).length > 0) {
                                    score += parseInt(v.score);
                                }
                            });
                            score = Math.pow(score, 3 - k);


                            if($.inArray(row, rows) !== -1) {
                                $row.data().score += score;
                            }
                            else {
                                $row.data().score = score;
                                rows.push(row);
                            }

                        });

                    });
                    var first = null;

                    $.each(rows, function (k, v) {
                        if(first === null) {
                            first = v;
                        }
                        else {
                            if($(v).data().score > $(first).data().score) {
                                first = v;
                            }
                        }
                    });
                    $("html, body").stop();
                    if(first !== null) {
                        setTimeout(function () {
                            $("html, body").animate({scrollTop: $(first).offset().top - 50}, 600);
                        }, 500);
                    }

                });



                function StickyHeader() {

                    var _this = this;
                    _this.off_top_pages = [
                        "home"
                    ];
                    _this.alwaysOffTop = true;

                    _this.$header = $("header");
                    _this.$header.data().controls = _this;
                    _this.fps = 60;
                    _this.speed = 300;
                    _this.headerHeight = _this.$header.outerHeight();
                    _this.headerStickAnimation = null;
                    _this.offset = 0;
                    _this.velocity = 0;
                    _this.oldTop = 0;
                    _this.newTop = 0;
                    _this.onAnimationDone = null;

                    _this._ticks = _this.speed/(1000/_this.fps);
                    _this._tick = 0;

                    $.each(_this.off_top_pages, function (index, value){
                        if($("body").hasClass(value)) {
                            _this.alwaysOffTop = false;
                        }
                    });

                    $(window).on('resize', function () {
                        _this.headerHeight = _this.$header.outerHeight();
                        if(_this.alwaysOffTop) {
                            $("body").css("padding-top", _this.headerHeight);
                        }
                    }).trigger("resize");


                    _this.animateHeader = function() {
                        _this._tick++;

                        var step = _this.direction > 0 ? (_this.offset-_this.headerTop)/_this._ticks : -(_this.headerTop-_this.offset)/_this._ticks;
                        var newTop = _this.headerTop+(step*_this._tick);
                        newTop = newTop > 0 ? 0 : newTop < -_this.headerHeight+1 ? -_this.headerHeight : newTop;
                        _this.$header.css("top", newTop).toggleClass("off-top", _this.newTop >= _this.$header.outerHeight() || _this.alwaysOffTop || $(window).scrollTop() < -_this.headerHeight/2);
                        if(_this._tick === Math.floor(_this._ticks)) {
                            _this.stopAnimation();
                        }
                    };

                    _this.stopAnimation = function() {
                        _this._tick = 0;
                        clearInterval(_this.headerStickAnimation);
                        _this.headerStickAnimation = null;
                        if(_this.onAnimationDone !== null) {
                            _this.onAnimationDone.call();
                        }
                        _this.onAnimationDone = null;
                    };

                    _this.startAnimation = function () {
                        // _this.stopAnimation();
                        if(_this.headerStickAnimation === null) {
                            _this.headerStickAnimation = setInterval(_this.animateHeader, 1000/_this.fps);
                        }
                    };

                    _this.showHeader = function(onAnimationDone) {
                        _this.onAnimationDone = onAnimationDone;
                        _this.offset = -1;
                        _this.direction = 1;
                        _this.startAnimation();
                    };

                    _this.hideHeader = function(onAnimationDone) {
                        _this.onAnimationDone = onAnimationDone;
                        _this.offset = -_this.headerHeight;
                        _this.direction = 0;
                        _this.startAnimation();
                    };

                    $(document).on("scroll.stick_header", function () {
                        var $this = $(this);
                        _this.newTop = $this.scrollTop() < 0 ? 0 : $this.scrollTop();
                        _this.velocity = _this.oldTop - _this.newTop;
                        _this.direction = _this.velocity > 0 ? -1 : 1;

                        _this.headerTop = parseInt(_this.$header.css("top"), 10);
                        _this.headerHeight = _this.$header.outerHeight();

                        // _this.offset = _this.velocity+_this.headerTop; // comment for animation
                        _this.offset += _this.velocity; // uncomment for animation
                        _this.offset = _this.offset > 0 ? 0 : _this.offset < -_this.headerHeight ? -_this.headerHeight : _this.offset;

                        // _this.$header.css("top", _this.offset).toggleClass("off-top", _this.newTop >= _this.headerHeight); // comment for animation

                        _this.startAnimation(); // uncomment for animation

                        _this.oldTop = _this.newTop;
                    }).trigger('scroll');
                }
                new StickyHeader();

                var $mobile_menu = $("nav.nav-primary.mobile");
                $mobile_menu.find(".close").on("click", function () {
                    $mobile_menu.removeClass("show");
                    $('body').removeClass('mobile-menu-open');
                });
                $("header .hamburger").on("click", function (e) {
                    $mobile_menu.addClass("show");
                    $('body').addClass('mobile-menu-open');
                    e.stopPropagation();
                });

                $(document).on("click touchend", function (e) {
                    if($mobile_menu.is(".show") && $(e.target).closest(".nav-primary.mobile").length <= 0) {
                        $mobile_menu.removeClass("show");
                        $('body').removeClass('mobile-menu-open');
                    }
                });

                $(document).on('touchstart', function (e) {
                    var $this = $(this);
                    $this.data().touchStart = {x: e.originalEvent.touches[0].pageX, y: e.originalEvent.touches[0].pageY};

                    $(document).trigger('ks_swipestart', [{
                        'touchStart': $this.data().touchStart
                    }]);
                });

                $(document).on('touchend', function (e) {
                    var $this = $(this);
                    $this.data().touchEnd = {x: e.originalEvent.changedTouches[0].pageX, y: e.originalEvent.changedTouches[0].pageY};

                    var touchStart = $this.data().touchStart;
                    var touchEnd = $this.data().touchEnd;

                    var diff = {x: touchStart.x - touchEnd.x, y: touchStart.y - touchEnd.y};

                    if(Math.abs(diff.y) < 80) {
                        if(diff.x > 0) {
                            $(document).trigger('ks_swipeleft', [{
                                'touchStart': touchStart,
                                'touchEnd': touchEnd,
                                'difference': diff,
                            }]);
                        }
                        else {
                            $(document).trigger('ks_swiperight', [{
                                'touchStart': touchStart,
                                'touchEnd': touchEnd,
                                'difference': diff,
                            }]);
                        }
                    }
                });

                $(document).on('ks_swipeleft', function (e, data) {
                    if(data.touchStart.x > window.innerWidth - 10 && Math.abs(data.difference.x) > window.innerWidth / 4) {
                        $mobile_menu.addClass("show");
                        $('body').addClass('mobile-menu-open');
                    }
                });

                if($('.woocommerce-message').length > 0) {
                    $('.woocommerce-message')
                    .append('<button type="button" class="close" data-dismiss="alert">×</button>')
                    .addClass('alert alert-dismissible alert-danger container')
                    .wrapAll('<div class="woocommerce-messages"></div>');
                }



                $(window).on('resize', function () {
                    if(this._ksLastWidth === window.innerWidth) {
                        return;
                    }
                    this._ksLastWidth = window.innerWidth;

                    if($('.modal-dialog').length > 0) {
                        $('.modal-dialog').each(function () {
                            var $this = $(this);
                            var top = $this.offset().top;
                            if(top < 0) {
                                $this.css({
                                    'transform': 'none',
                                    'top': 0
                                });
                            }
                        });
                    }

                    if($('.woocommerce-message').length > 0) {
                        var $notice = $('.woocommerce-messages, .woocommerce-NoticeGroup');
                        $notice.each(function () {
                            var $this = $(this);
                            if(!$this.parent().is('main')) {
                                $this.detach().prependTo('main');
                            }
                            $this.css({'left': ''});
                            $this.css({'left': -$this.offset().left});
                        });
                    }


                    $('.featured-image.full').each(function () {
                        var $this = $(this);
                        var side = $this.closest(".left").length >= 1 ? "left" : $this.closest(".right").length >= 1 ? "right" : null;
                        var left = $this.offset().left;
                        var width = side === 'left' ? left+ $this.outerWidth() : side === "right" ? window.innerWidth - left : 0;
                        $this.css("min-width", window.innerWidth > 767 ? width : "");
                    });

                    $(".featured-image").each(function () {
                        if($(this).is('.full-height')) {
                            if( window.innerWidth > 767) {
                                $(this).parent().css({
                                    'height': '100%',
                                    'position': 'absolute',
                                    'width': '100%',
                                    'right': '0',
                                    'left': '0',
                                    'top': '0'
                                });
                            }
                            else {
                                $(this).parent().css({
                                    'height': '',
                                    'position': '',
                                    'width': '',
                                    'right': '',
                                    'left': '',
                                });
                            }

                        }
                    });

                    // $(".ks-coupons .coupon .thumb").each(function () {
                    //     new MobileFullWidth($(this), {
                    //         _containerHeight: "308px",
                    //         containerHeight: "auto",
                    //         maxWidth: 10000,
                    //         width: '100%',
                    //         responsive: {
                    //             767: {
                    //
                    //             }
                    //         }
                    //     });
                    // });

                    $('.ks-quote .quotemark').each(function () {
                        var $this = $(this);
                        $this.removeClass('at-top');
                        var offset = $this.offset();

                        $this.toggleClass("at-top", offset.left < 0 || offset.left+$this.outerHeight() > window.innerWidth);

                    });

                    $(".full-width, .full_width").each(function () {
                        var $this = $(this);
                        $this.css("left", "");
                        var offset = $this.offset().left;
                        $this.css({
                            "left": -offset,
                            "width": $('body').innerWidth()
                        });
                    });

                    $('body').css('padding-bottom', $('footer').outerHeight(true));
                }).trigger('resize');

                // mobile full width

                $(".featured-image").each(function () {
                    if($(this).is('.full-height')) {
                        new MobileFullWidth($(this), {
                            containerHeight: "100%",
                            _containerHeight: "100%",
                            maxWidth: 10000,
                            width: '100%',
                            responsive: {
                                767: $(this).data()
                            }
                        });
                    }
                    else {
                        new MobileFullWidth($(this));
                    }
                });

                // UPDATE CART Count


                $(document.body).on('added_to_cart', function () {
                    var $cart_count = $('header .cart-count');
                    $.ajax({
                        type: "POST",
                        url: woocommerce_params.ajax_url+'?action='+"ks_update_cart"
                    }).done(function (response) {
                        response = JSON.parse(response);
                        $cart_count.html('('+response.count+')');
                    });
                });



                $('.coupon .thumb').each(function () {
                    new MobileFullWidth($(this), {
                        containerHeight: "100%",
                        _containerHeight: "100%",
                        maxWidth: 10000,
                        width: '100%'
                    });
                });

                $(document.body).on('shown.bs.modal', '#wcp_choose_value',function () {

                    $(this).find('.coupon .thumb').each(function () {
                        new MobileFullWidth($(this), {
                            containerHeight: "100%",
                            _containerHeight: "100%",
                            maxWidth: 10000,
                            width: '100%'
                        });
                    });

                    $(document.body).trigger('lqip');

                    $(this).on('switched.bs.modal', function () {
                        $(this).find('.coupon .thumb').each(function () {
                            new MobileFullWidth($(this), {
                                containerHeight: "100%",
                                _containerHeight: "100%",
                                maxWidth: 10000,
                                width: '100%'
                            });
                        });
                        $(document.body).trigger('lqip');
                    });
                });










                $('.ks-table-row.c').on("click", function () {
                    var $trigger = $(this);
                    var $collapse = $trigger.find(".collapse, .collapsing");
                    try {
                        $collapse.collapse(!$collapse.is(':visible') ? "show" : "hide");
                        $trigger.closest('.ks-table').find('.collapse, .collapsing').not($collapse).collapse("hide");
                    }
                    catch(err) {
                        // probably transitioning
                    }
                });

                $('.ks-table-row.c .collapse').on("show.bs.collapse hide.bs.collapse", function () {
                    $(this).closest('.ks-table-row').toggleClass('is-open', $(this).is(':visible') ? "true" : "false");
                });


                // $(".ks-table").each(function () {
                // 	var $this = $(this);
                // 	$this.find(">.ks-table-row").last().addClass("last");
                // 	$this.find(">.ks-table-row").not('.c').last().addClass("last");
                // 	$this.find(">.ks-table-row").first().addClass("first");
                // 	$this.find(">.ks-table-row.hidden.c").first().addClass("first");
                // });

                $(window).on('resize.ks-table-heads', function () {

                    $(".ks-table").each(function () {
                        var $this = $(this);
                        $this.find(">.ks-table-row").removeClass("last first");
                        $this.find(">.ks-table-row:visible").last().addClass("last");
                        $this.find(">.ks-table-row:visible").first().addClass("first");
                    });


                    $(".ks-table").each(function () {
                        var $this = $(this);
                        if($this.find('.ks-table-head').length > 0) {
                            $this.find('.ks-table-col-head').each(function (column_index) {
                                var max_width = 0;
                                $this.find('>.ks-table-row').not('.ks-table-head').each(function () {
                                    var w = $(this).find('>[class*=ks-table-col]').eq(column_index).outerWidth();
                                    if(w > max_width) {
                                        max_width = w;
                                    }
                                });
                                $(this).css('max-width', max_width);
                            });
                        }
                    });

                    $('.collapse_2 .row-head .center-me').each(function () {
                        var lineCount = $(this).height()/25;
                        if(lineCount === 1) {
                            $(this).closest('.row-head').css('min-height', 25);
                        }
                        else {
                            $(this).closest('.row-head').css('min-height', '');
                        }
                    });
                }).trigger('resize.ks-table-heads');
            },
            finalize: function() {
                // JavaScript to be fired on all pages, after page specific JS is fired
            }
        },
        'single_professional': {
            init: function() {

                $(window).on('load', function () {
                    $(window).on('resize', function () {

                        $('.gallery-image-container img').each(function () {
                            var $this = $(this);
                            var $container = $this.parent();
                            $this.css('width', '100%');
                            $this.css('height', 'auto');

                            if($this.height() < $container.height()) {
                                $this.css('width', $container.height()*$this.width()/$this.height());
                            }

                            if($this.width() < $container.width()) {
                                $this.css('height', $container.width()*$this.height()/$this.width());
                            }

                        });
                    }).trigger('resize');
                });



                $(document).ready(function () {
                    $('.ks-table-row-head').on("click", function () {
                        var $trigger = $(this);
                        var $collapse = $trigger.next(".collapse, .collapsing");
                        try {
                            $collapse.collapse(!$collapse.is(':visible') ? "show" : "hide");

                            $trigger.closest('.ks-table').find('.collapse, .collapsing').not($collapse).collapse("hide");
                        }
                        catch(err) {
                            // probably transitioning
                        }
                    });

                    $('.ks-table-row .collapse').on("show.bs.collapse hide.bs.collapse", function () {
                        $(this).closest('.ks-table-row').toggleClass('is-open', $(this).is(':visible') ? "true" : "false");
                    });

                    $('.grid-item > div, .gallery-image-container > div').each(function () {
                        new MobileFullWidth($(this), {
                            _containerHeight: '100%',
                            maxWidth: 10000,
                            width: '100%'
                        });
                    });


                    if($('.gallery-full').length > 0) {
                        $('.grid').on('resize.rg.before', function () {
                            // default values
                            $('.grid-item').each(function () {
                                var $this = $(this);
                                if(typeof $this.data().defaults === 'undefined') {
                                    $this.data().defaults = {};
                                    jQuery.extend($this.data().defaults, $this.data());
                                }

                                if(window.innerWidth < 576) {
                                    $this.data('rowspan', 1);
                                    $this.data('colspan', 1);

                                }
                                else {
                                    $this.data('rowspan', $this.data().defaults.rowspan);
                                    $this.data('colspan', $this.data().defaults.colspan);
                                }
                            });




                        }).trigger('resize.rg.before');


                        $('.grid').responsivegrid({
                            'breakpoints': {
                                'desktop' : {
                                    'range' : '*',
                                    'options' : {
                                        'column' : 3,
                                        'gutter' : '15px',
                                        'itemHeight' : '380px',
                                    }
                                },
                                'tablet-landscape' : {
                                    'range' : '1000-1200',
                                    'options' : {
                                        'column' : 3,
                                        'gutter' : '15px',
                                        'itemHeight' : '380px',
                                    }
                                },
                                'tablet-portrate' : {
                                    'range' : '767-1000',
                                    'options' : {
                                        'column' : 3,
                                        'gutter' : '15px',
                                        'itemHeight' : '240px',
                                    }
                                },
                                'mobile' : {
                                    'range' : '576-767',
                                    'options' : {
                                        'column' : 2,
                                        'gutter' : '15px',
                                        'itemHeight' : '280px',
                                    }
                                },
                                'mobilexs' : {
                                    'range' : '-576',
                                    'options' : {
                                        'column' : 1,
                                        'gutter' : '15px',
                                        'itemHeight' : '100%',
                                    }
                                }
                            }
                        });


                        $(window).on('load', function () {
                            $('.grid').on('resize.rg.after', function () {
                                AOS.refresh();
                            }).trigger('resize.rg.after');

                        });

                        AOS.init({
                            startEvent: 'load'
                        });

                    }
                });



            },
            finalize: function() {
                // JavaScript to be fired on the home page, after the init JS
            }
        },
        'home': {
            init: function() {
                // JavaScript to be fired on the home page
                $('.ks-home-head').each(function () {
                    var hhfw = new MobileFullWidth($(this), {
                        _containerHeight: window.innerHeight - 115,
                        maxWidth: 10000,
                        centerY: 0,
                        width: '100%'
                    });

                });


                $('.ks-gallery-home').slick();
                $('.home-gallery-slide > div').each(function () {
                    new MobileFullWidth($(this), {
                        _containerHeight: '618px',
                        maxWidth: 10000,
                        width: '100%',
                        responsive: {
                            990: {
                                _containerHeight: '450px',
                            },
                            767: {
                                _containerHeight: '389px',
                            }
                        }
                    });
                });


            },
            finalize: function() {
                // JavaScript to be fired on the home page, after the init JS
            }
        },
        'single_product': {
            init: function() {
                // JavaScript to be fired on the home page

                // $(window).on('resize', function () {
                //     $('.enter-coupon-price .form-control').on('keyup change', function () {
                //         $(this).nextAll('.currency').css('left', ($(this).width()/2)+($(this).val().length*4.8));
                //     }).trigger('change');
                // }).trigger('resize');

                // $('.enter-coupon-price .form-control').on('change click blur', function () {
                //     var $this = $(this);
                //     var min = parseInt($this.attr('min'));
                //     var max = parseInt($this.attr('max'));
                //     var currency = $this.attr('data-currency');
                //     var input = $this.val();
                //     var $inputHelper = $this.parent().find('.input-helper');
                //
                //     var value = $this.toFloat();
                //
                //     $inputHelper.html();
                //     $inputHelper.closest('.form-group').removeClass('has-error');
                //     if(value > max) {
                //         value = max;
                //         $inputHelper.html(ks_strings.lower_than + ' ' + max + currency);
                //         $inputHelper.closest('.form-group').addClass('has-error');
                //     }
                //     if(value < min) {
                //         value = min;
                //         $inputHelper.html(ks_strings.higher_than + ' ' + min + currency);
                //         $inputHelper.closest('.form-group').addClass('has-error');
                //     }
                //
                //     $this.val(value);
                //
                // })
                // .trigger('change');

                // .on('dbclick', function () {
                //     var $this = $(this);
                //     var value = $this.toFloat();
                //     $this.selectRange(0, value.toString().length);
                // })
                // .on('click', function () {
                //     var $this = $(this);
                //     var l = $this.val().length - 2;
                //     if($this[0].selectionEnd > l) {
                //         if($this[0].selectionStart === 0) {
                //             $this.selectRange(0, l);
                //         }
                //         else {
                //             $this.selectRange(l);
                //         }
                //     }
                // });


            },
            finalize: function() {
                // JavaScript to be fired on the home page, after the init JS
            }
        },
        'woocommerce_checkout': {
            init: function() {
                // JavaScript to be fired on the home page

                var $order_review = $('#order_review');
                var $hb = $( 'html, body' );
                var $checkout = $('.woocommerce-checkout');
                // $order_review.affix({
                //     offset: $('header').height(),
                //     offsetTop: $('.fields > h2').outerHeight() - 1
                // });

                

                $( document.body ).on( 'checkout_error', function () {
                    if($('.woocommerce-message').length > 0) {
                        var $notice = $('.woocommerce-messages, .woocommerce-NoticeGroup');


                        $notice.each(function () {
                            var $this = $(this);
                            if(!$this.parent().is('main')) {
                                $this.detach().prependTo('main');
                            }
                            $this.css({'left': ''});
                            $this.css({'left': -$this.offset().left});
                        });

                    }


                    var count = 0;
                    var interval = setInterval(function () {
                        count++;
                        if($hb.is(':animated')) {
                            // Scroll Top has been stopped
                            $hb.clearQueue();
                            $hb.stop();
                            clearInterval(interval);

                            // So we continue
                            // to locate our own errors
                            var $first_error = $checkout.find('.woocommerce-error, .woocommerce-message, .has-error').first();
                            $first_error.focus();
                            $hb.animate({
                                scrollTop: $first_error.offset().top - $('header').outerHeight(true) - 50
                            }, 600, function() {
                                $hb.off("scroll.cerror mousedown.cerror wheel.cerror DOMMouseScroll.cerror mousewheel.cerror keyup.cerror touchmove.cerror");
                            });

                            $hb.on("scroll.cerror mousedown.cerror wheel.cerror DOMMouseScroll.cerror mousewheel.cerror keyup.cerror touchmove.cerror", function() {
                                $hb.clearQueue();
                                $hb.stop();
                            });
                        }


                        // Just in case
                        if(count > 100) {
                            clearInterval(interval);
                        }
                    }, 30);
                });

                $(document.body).on('updated_checkout', function () {
                    $order_review = $('#order_review');
                    $(window).trigger('resize.order-review');
                    $(document.body).trigger('lqip');

                    if($order_review.length < 1) {
                        location.reload();
                    }


                });

                $(document.body).on('click', '[name="payment_method"]', function () {
                    $('[name="payment_method"]').each(function () {
                        $(this).not(':checked').parent().removeClass('active');
                        $(this).filter(':checked').parent().addClass('active');
                    });
                });


                $(document.body).on('click', '#order_review .remove', function () {
                    $.ajax({
                        type: "POST",
                        url: woocommerce_params.ajax_url+'?action='+"checkout_remove_item",
                        data: {key: $(this).data().cart_item_key}
                    }).done(function (response) {
                        $( document.body ).trigger( 'update_checkout' );
                    });
                });



                // Responsive Move Order Review

                $(window).on('resize.order-review', function () {
                    var w = window.innerWidth;
                    if(767 >= w) {
                        $order_review.detach().insertAfter('.fields .f');
                        $order_review.affixOff();
                    }
                    else {
                        $order_review.detach().appendTo('.order-review');
                        $order_review.affix({
                            offset: $('header').height(),
                            offsetTop: $('.fields > h2').outerHeight() - 1,
                            offsetBottom: $('#payment').outerHeight(true) - 46
                        });
                    }
                }).trigger('resize.order-review');




            },
            finalize: function() {
                // JavaScript to be fired on the home page, after the init JS
            }
        },
        'woocommerce_cart': {
            init: function() {
                // JavaScript to be fired on the home page


                // Align all rows
                // $(window).on('resize', function () {
                //
                //     $('.shop_table .woocommerce-cart-form__cart-item').each(function () {
                //         if($(window).innerWidth() > 767) {
                //             var heighest = 0;
                //             $(this).find('td .tt').each(function () {
                //                 heighest = $(this).innerHeight() > heighest ? $(this).innerHeight() : heighest;
                //             });
                //             $(this).find('td .tt').css('min-height', heighest);
                //         }
                //         else {
                //             $(this).find('td .tt').css('min-height', '');
                //         }
                //     });
                //
                // }).trigger('resize');

                $(document.body).on('change', '.quantity input.qty', function () {
                    clearTimeout($(this).data().updateTimer);
                    $(this).data().updateTimer = setTimeout(function () {
                        wcp_cart.quantity_update( $(".woocommerce-cart-form") );
                    }, 1000);

                });

                $(document.body).on('cart_updated', function () {
                    $(document.body).trigger('added_to_cart');
                });
                $(document.body).on('wc_fragments_refreshed updated_wc_div', function (e) {
                    setTimeout(function () {
                        $(document.body).trigger('lqip');
                    }, 1000);
                });



                $(document.body).on('click', '.quantity-controls > .positive, .quantity-controls > .negative', function (e) {
                    e.preventDefault();
                    var $input = $(this).closest('.tt').find('input.qty');
                    if($(this).is('.positive')) {
                        $input.val(function (i, o) {
                            return ++o;
                        });
                    }
                    else {
                        $input.val(function (i, o) {
                            return --o;
                        });
                    }
                    $input.trigger('change');
                });


            },
            finalize: function() {
                // JavaScript to be fired on the home page, after the init JS
            }
        },
        // About us page, note the change from about-us to about_us.
        'about_us': {
            init: function() {
                // JavaScript to be fired on the about us page
            }
        },
        // About us page, note the change from about-us to about_us.
        'page_id_408': { // GAallery
            init: function() {
                // JavaScript to be fired on the about us page
                $(".galleries .thumb").each(function () {
                    new MobileFullWidth($(this), {
                        containerHeight: "100%",
                        _containerHeight: "100%",
                        maxWidth: 10000,
                        width: '100%'
                    });
                });

            }
        },
        'nagu_prieziura': { // GAallery
            init: function() {
                // JavaScript to be fired on the about us page


            }
        },
        'single_gallery': {
            init: function() {
                // JavaScript to be fired on the about us page
                var $slick = $('.ks-single-gallery-slick');
                $slick.slick({
                    'lazyLoad':'ondemand',
                    'centerPadding': '500px',
                    'respondTo': 'slider',
                    'touchThreshold': 5,
                    'slidesToShow': 1,
                    'slidesToScroll': 1,
                    'centerMode': 1,
                    'waitForAnimate': true
                });

                $(".galleries .thumb").each(function () {
                    new MobileFullWidth($(this), {
                        containerHeight: "100%",
                        _containerHeight: "100%",
                        maxWidth: 10000,
                        width: '100%'
                    });
                });
            }
        }
    };

    // The routing fires all common scripts, followed by the page specific scripts.
    // Add additional events for more control over timing e.g. a finalize event
    var UTIL = {
        fire: function(func, funcname, args) {
            var fire;
            var namespace = Sage;
            funcname = (funcname === undefined) ? 'init' : funcname;
            fire = func !== '';
            fire = fire && namespace[func];
            fire = fire && typeof namespace[func][funcname] === 'function';

            if (fire) {
                namespace[func][funcname](args);
            }
        },
        loadEvents: function() {
            // Fire common init JS
            UTIL.fire('common');

            // Fire page-specific init JS, and then finalize JS
            $.each(document.body.className.replace(/-/g, '_').split(/\s+/), function(i, classnm) {
                UTIL.fire(classnm);
                UTIL.fire(classnm, 'finalize');
            });

            // Fire common finalize JS
            UTIL.fire('common', 'finalize');
        }
    };

    // Load Events
    $(document).ready(UTIL.loadEvents);

})(jQuery); // Fully reference jQuery after this point.

var Latinise={};
Latinise.latin_map={
    "Á":"A",
    "Ă":"A",
    "Ắ":"A",
    "Ặ":"A",
    "Ằ":"A",
    "Ẳ":"A",
    "Ẵ":"A",
    "Ǎ":"A",
    "Â":"A",
    "Ấ":"A",
    "Ậ":"A",
    "Ầ":"A",
    "Ẩ":"A",
    "Ẫ":"A",
    "Ä":"A",
    "Ǟ":"A",
    "Ȧ":"A",
    "Ǡ":"A",
    "Ạ":"A",
    "Ȁ":"A",
    "À":"A",
    "Ả":"A",
    "Ȃ":"A",
    "Ā":"A",
    "Ą":"A",
    "Å":"A",
    "Ǻ":"A",
    "Ḁ":"A",
    "Ⱥ":"A",
    "Ã":"A",
    "Ꜳ":"AA",
    "Æ":"AE",
    "Ǽ":"AE",
    "Ǣ":"AE",
    "Ꜵ":"AO",
    "Ꜷ":"AU",
    "Ꜹ":"AV",
    "Ꜻ":"AV",
    "Ꜽ":"AY",
    "Ḃ":"B",
    "Ḅ":"B",
    "Ɓ":"B",
    "Ḇ":"B",
    "Ƀ":"B",
    "Ƃ":"B",
    "Ć":"C",
    "Č":"C",
    "Ç":"C",
    "Ḉ":"C",
    "Ĉ":"C",
    "Ċ":"C",
    "Ƈ":"C",
    "Ȼ":"C",
    "Ď":"D",
    "Ḑ":"D",
    "Ḓ":"D",
    "Ḋ":"D",
    "Ḍ":"D",
    "Ɗ":"D",
    "Ḏ":"D",
    "ǲ":"D",
    "ǅ":"D",
    "Đ":"D",
    "Ƌ":"D",
    "Ǳ":"DZ",
    "Ǆ":"DZ",
    "É":"E",
    "Ĕ":"E",
    "Ě":"E",
    "Ȩ":"E",
    "Ḝ":"E",
    "Ê":"E",
    "Ế":"E",
    "Ệ":"E",
    "Ề":"E",
    "Ể":"E",
    "Ễ":"E",
    "Ḙ":"E",
    "Ë":"E",
    "Ė":"E",
    "Ẹ":"E",
    "Ȅ":"E",
    "È":"E",
    "Ẻ":"E",
    "Ȇ":"E",
    "Ē":"E",
    "Ḗ":"E",
    "Ḕ":"E",
    "Ę":"E",
    "Ɇ":"E",
    "Ẽ":"E",
    "Ḛ":"E",
    "Ꝫ":"ET",
    "Ḟ":"F",
    "Ƒ":"F",
    "Ǵ":"G",
    "Ğ":"G",
    "Ǧ":"G",
    "Ģ":"G",
    "Ĝ":"G",
    "Ġ":"G",
    "Ɠ":"G",
    "Ḡ":"G",
    "Ǥ":"G",
    "Ḫ":"H",
    "Ȟ":"H",
    "Ḩ":"H",
    "Ĥ":"H",
    "Ⱨ":"H",
    "Ḧ":"H",
    "Ḣ":"H",
    "Ḥ":"H",
    "Ħ":"H",
    "Í":"I",
    "Ĭ":"I",
    "Ǐ":"I",
    "Î":"I",
    "Ï":"I",
    "Ḯ":"I",
    "İ":"I",
    "Ị":"I",
    "Ȉ":"I",
    "Ì":"I",
    "Ỉ":"I",
    "Ȋ":"I",
    "Ī":"I",
    "Į":"I",
    "Ɨ":"I",
    "Ĩ":"I",
    "Ḭ":"I",
    "Ꝺ":"D",
    "Ꝼ":"F",
    "Ᵹ":"G",
    "Ꞃ":"R",
    "Ꞅ":"S",
    "Ꞇ":"T",
    "Ꝭ":"IS",
    "Ĵ":"J",
    "Ɉ":"J",
    "Ḱ":"K",
    "Ǩ":"K",
    "Ķ":"K",
    "Ⱪ":"K",
    "Ꝃ":"K",
    "Ḳ":"K",
    "Ƙ":"K",
    "Ḵ":"K",
    "Ꝁ":"K",
    "Ꝅ":"K",
    "Ĺ":"L",
    "Ƚ":"L",
    "Ľ":"L",
    "Ļ":"L",
    "Ḽ":"L",
    "Ḷ":"L",
    "Ḹ":"L",
    "Ⱡ":"L",
    "Ꝉ":"L",
    "Ḻ":"L",
    "Ŀ":"L",
    "Ɫ":"L",
    "ǈ":"L",
    "Ł":"L",
    "Ǉ":"LJ",
    "Ḿ":"M",
    "Ṁ":"M",
    "Ṃ":"M",
    "Ɱ":"M",
    "Ń":"N",
    "Ň":"N",
    "Ņ":"N",
    "Ṋ":"N",
    "Ṅ":"N",
    "Ṇ":"N",
    "Ǹ":"N",
    "Ɲ":"N",
    "Ṉ":"N",
    "Ƞ":"N",
    "ǋ":"N",
    "Ñ":"N",
    "Ǌ":"NJ",
    "Ó":"O",
    "Ŏ":"O",
    "Ǒ":"O",
    "Ô":"O",
    "Ố":"O",
    "Ộ":"O",
    "Ồ":"O",
    "Ổ":"O",
    "Ỗ":"O",
    "Ö":"O",
    "Ȫ":"O",
    "Ȯ":"O",
    "Ȱ":"O",
    "Ọ":"O",
    "Ő":"O",
    "Ȍ":"O",
    "Ò":"O",
    "Ỏ":"O",
    "Ơ":"O",
    "Ớ":"O",
    "Ợ":"O",
    "Ờ":"O",
    "Ở":"O",
    "Ỡ":"O",
    "Ȏ":"O",
    "Ꝋ":"O",
    "Ꝍ":"O",
    "Ō":"O",
    "Ṓ":"O",
    "Ṑ":"O",
    "Ɵ":"O",
    "Ǫ":"O",
    "Ǭ":"O",
    "Ø":"O",
    "Ǿ":"O",
    "Õ":"O",
    "Ṍ":"O",
    "Ṏ":"O",
    "Ȭ":"O",
    "Ƣ":"OI",
    "Ꝏ":"OO",
    "Ɛ":"E",
    "Ɔ":"O",
    "Ȣ":"OU",
    "Ṕ":"P",
    "Ṗ":"P",
    "Ꝓ":"P",
    "Ƥ":"P",
    "Ꝕ":"P",
    "Ᵽ":"P",
    "Ꝑ":"P",
    "Ꝙ":"Q",
    "Ꝗ":"Q",
    "Ŕ":"R",
    "Ř":"R",
    "Ŗ":"R",
    "Ṙ":"R",
    "Ṛ":"R",
    "Ṝ":"R",
    "Ȑ":"R",
    "Ȓ":"R",
    "Ṟ":"R",
    "Ɍ":"R",
    "Ɽ":"R",
    "Ꜿ":"C",
    "Ǝ":"E",
    "Ś":"S",
    "Ṥ":"S",
    "Š":"S",
    "Ṧ":"S",
    "Ş":"S",
    "Ŝ":"S",
    "Ș":"S",
    "Ṡ":"S",
    "Ṣ":"S",
    "Ṩ":"S",
    "Ť":"T",
    "Ţ":"T",
    "Ṱ":"T",
    "Ț":"T",
    "Ⱦ":"T",
    "Ṫ":"T",
    "Ṭ":"T",
    "Ƭ":"T",
    "Ṯ":"T",
    "Ʈ":"T",
    "Ŧ":"T",
    "Ɐ":"A",
    "Ꞁ":"L",
    "Ɯ":"M",
    "Ʌ":"V",
    "Ꜩ":"TZ",
    "Ú":"U",
    "Ŭ":"U",
    "Ǔ":"U",
    "Û":"U",
    "Ṷ":"U",
    "Ü":"U",
    "Ǘ":"U",
    "Ǚ":"U",
    "Ǜ":"U",
    "Ǖ":"U",
    "Ṳ":"U",
    "Ụ":"U",
    "Ű":"U",
    "Ȕ":"U",
    "Ù":"U",
    "Ủ":"U",
    "Ư":"U",
    "Ứ":"U",
    "Ự":"U",
    "Ừ":"U",
    "Ử":"U",
    "Ữ":"U",
    "Ȗ":"U",
    "Ū":"U",
    "Ṻ":"U",
    "Ų":"U",
    "Ů":"U",
    "Ũ":"U",
    "Ṹ":"U",
    "Ṵ":"U",
    "Ꝟ":"V",
    "Ṿ":"V",
    "Ʋ":"V",
    "Ṽ":"V",
    "Ꝡ":"VY",
    "Ẃ":"W",
    "Ŵ":"W",
    "Ẅ":"W",
    "Ẇ":"W",
    "Ẉ":"W",
    "Ẁ":"W",
    "Ⱳ":"W",
    "Ẍ":"X",
    "Ẋ":"X",
    "Ý":"Y",
    "Ŷ":"Y",
    "Ÿ":"Y",
    "Ẏ":"Y",
    "Ỵ":"Y",
    "Ỳ":"Y",
    "Ƴ":"Y",
    "Ỷ":"Y",
    "Ỿ":"Y",
    "Ȳ":"Y",
    "Ɏ":"Y",
    "Ỹ":"Y",
    "Ź":"Z",
    "Ž":"Z",
    "Ẑ":"Z",
    "Ⱬ":"Z",
    "Ż":"Z",
    "Ẓ":"Z",
    "Ȥ":"Z",
    "Ẕ":"Z",
    "Ƶ":"Z",
    "Ĳ":"IJ",
    "Œ":"OE",
    "ᴀ":"A",
    "ᴁ":"AE",
    "ʙ":"B",
    "ᴃ":"B",
    "ᴄ":"C",
    "ᴅ":"D",
    "ᴇ":"E",
    "ꜰ":"F",
    "ɢ":"G",
    "ʛ":"G",
    "ʜ":"H",
    "ɪ":"I",
    "ʁ":"R",
    "ᴊ":"J",
    "ᴋ":"K",
    "ʟ":"L",
    "ᴌ":"L",
    "ᴍ":"M",
    "ɴ":"N",
    "ᴏ":"O",
    "ɶ":"OE",
    "ᴐ":"O",
    "ᴕ":"OU",
    "ᴘ":"P",
    "ʀ":"R",
    "ᴎ":"N",
    "ᴙ":"R",
    "ꜱ":"S",
    "ᴛ":"T",
    "ⱻ":"E",
    "ᴚ":"R",
    "ᴜ":"U",
    "ᴠ":"V",
    "ᴡ":"W",
    "ʏ":"Y",
    "ᴢ":"Z",
    "á":"a",
    "ă":"a",
    "ắ":"a",
    "ặ":"a",
    "ằ":"a",
    "ẳ":"a",
    "ẵ":"a",
    "ǎ":"a",
    "â":"a",
    "ấ":"a",
    "ậ":"a",
    "ầ":"a",
    "ẩ":"a",
    "ẫ":"a",
    "ä":"a",
    "ǟ":"a",
    "ȧ":"a",
    "ǡ":"a",
    "ạ":"a",
    "ȁ":"a",
    "à":"a",
    "ả":"a",
    "ȃ":"a",
    "ā":"a",
    "ą":"a",
    "ᶏ":"a",
    "ẚ":"a",
    "å":"a",
    "ǻ":"a",
    "ḁ":"a",
    "ⱥ":"a",
    "ã":"a",
    "ꜳ":"aa",
    "æ":"ae",
    "ǽ":"ae",
    "ǣ":"ae",
    "ꜵ":"ao",
    "ꜷ":"au",
    "ꜹ":"av",
    "ꜻ":"av",
    "ꜽ":"ay",
    "ḃ":"b",
    "ḅ":"b",
    "ɓ":"b",
    "ḇ":"b",
    "ᵬ":"b",
    "ᶀ":"b",
    "ƀ":"b",
    "ƃ":"b",
    "ɵ":"o",
    "ć":"c",
    "č":"c",
    "ç":"c",
    "ḉ":"c",
    "ĉ":"c",
    "ɕ":"c",
    "ċ":"c",
    "ƈ":"c",
    "ȼ":"c",
    "ď":"d",
    "ḑ":"d",
    "ḓ":"d",
    "ȡ":"d",
    "ḋ":"d",
    "ḍ":"d",
    "ɗ":"d",
    "ᶑ":"d",
    "ḏ":"d",
    "ᵭ":"d",
    "ᶁ":"d",
    "đ":"d",
    "ɖ":"d",
    "ƌ":"d",
    "ı":"i",
    "ȷ":"j",
    "ɟ":"j",
    "ʄ":"j",
    "ǳ":"dz",
    "ǆ":"dz",
    "é":"e",
    "ĕ":"e",
    "ě":"e",
    "ȩ":"e",
    "ḝ":"e",
    "ê":"e",
    "ế":"e",
    "ệ":"e",
    "ề":"e",
    "ể":"e",
    "ễ":"e",
    "ḙ":"e",
    "ë":"e",
    "ė":"e",
    "ẹ":"e",
    "ȅ":"e",
    "è":"e",
    "ẻ":"e",
    "ȇ":"e",
    "ē":"e",
    "ḗ":"e",
    "ḕ":"e",
    "ⱸ":"e",
    "ę":"e",
    "ᶒ":"e",
    "ɇ":"e",
    "ẽ":"e",
    "ḛ":"e",
    "ꝫ":"et",
    "ḟ":"f",
    "ƒ":"f",
    "ᵮ":"f",
    "ᶂ":"f",
    "ǵ":"g",
    "ğ":"g",
    "ǧ":"g",
    "ģ":"g",
    "ĝ":"g",
    "ġ":"g",
    "ɠ":"g",
    "ḡ":"g",
    "ᶃ":"g",
    "ǥ":"g",
    "ḫ":"h",
    "ȟ":"h",
    "ḩ":"h",
    "ĥ":"h",
    "ⱨ":"h",
    "ḧ":"h",
    "ḣ":"h",
    "ḥ":"h",
    "ɦ":"h",
    "ẖ":"h",
    "ħ":"h",
    "ƕ":"hv",
    "í":"i",
    "ĭ":"i",
    "ǐ":"i",
    "î":"i",
    "ï":"i",
    "ḯ":"i",
    "ị":"i",
    "ȉ":"i",
    "ì":"i",
    "ỉ":"i",
    "ȋ":"i",
    "ī":"i",
    "į":"i",
    "ᶖ":"i",
    "ɨ":"i",
    "ĩ":"i",
    "ḭ":"i",
    "ꝺ":"d",
    "ꝼ":"f",
    "ᵹ":"g",
    "ꞃ":"r",
    "ꞅ":"s",
    "ꞇ":"t",
    "ꝭ":"is",
    "ǰ":"j",
    "ĵ":"j",
    "ʝ":"j",
    "ɉ":"j",
    "ḱ":"k",
    "ǩ":"k",
    "ķ":"k",
    "ⱪ":"k",
    "ꝃ":"k",
    "ḳ":"k",
    "ƙ":"k",
    "ḵ":"k",
    "ᶄ":"k",
    "ꝁ":"k",
    "ꝅ":"k",
    "ĺ":"l",
    "ƚ":"l",
    "ɬ":"l",
    "ľ":"l",
    "ļ":"l",
    "ḽ":"l",
    "ȴ":"l",
    "ḷ":"l",
    "ḹ":"l",
    "ⱡ":"l",
    "ꝉ":"l",
    "ḻ":"l",
    "ŀ":"l",
    "ɫ":"l",
    "ᶅ":"l",
    "ɭ":"l",
    "ł":"l",
    "ǉ":"lj",
    "ſ":"s",
    "ẜ":"s",
    "ẛ":"s",
    "ẝ":"s",
    "ḿ":"m",
    "ṁ":"m",
    "ṃ":"m",
    "ɱ":"m",
    "ᵯ":"m",
    "ᶆ":"m",
    "ń":"n",
    "ň":"n",
    "ņ":"n",
    "ṋ":"n",
    "ȵ":"n",
    "ṅ":"n",
    "ṇ":"n",
    "ǹ":"n",
    "ɲ":"n",
    "ṉ":"n",
    "ƞ":"n",
    "ᵰ":"n",
    "ᶇ":"n",
    "ɳ":"n",
    "ñ":"n",
    "ǌ":"nj",
    "ó":"o",
    "ŏ":"o",
    "ǒ":"o",
    "ô":"o",
    "ố":"o",
    "ộ":"o",
    "ồ":"o",
    "ổ":"o",
    "ỗ":"o",
    "ö":"o",
    "ȫ":"o",
    "ȯ":"o",
    "ȱ":"o",
    "ọ":"o",
    "ő":"o",
    "ȍ":"o",
    "ò":"o",
    "ỏ":"o",
    "ơ":"o",
    "ớ":"o",
    "ợ":"o",
    "ờ":"o",
    "ở":"o",
    "ỡ":"o",
    "ȏ":"o",
    "ꝋ":"o",
    "ꝍ":"o",
    "ⱺ":"o",
    "ō":"o",
    "ṓ":"o",
    "ṑ":"o",
    "ǫ":"o",
    "ǭ":"o",
    "ø":"o",
    "ǿ":"o",
    "õ":"o",
    "ṍ":"o",
    "ṏ":"o",
    "ȭ":"o",
    "ƣ":"oi",
    "ꝏ":"oo",
    "ɛ":"e",
    "ᶓ":"e",
    "ɔ":"o",
    "ᶗ":"o",
    "ȣ":"ou",
    "ṕ":"p",
    "ṗ":"p",
    "ꝓ":"p",
    "ƥ":"p",
    "ᵱ":"p",
    "ᶈ":"p",
    "ꝕ":"p",
    "ᵽ":"p",
    "ꝑ":"p",
    "ꝙ":"q",
    "ʠ":"q",
    "ɋ":"q",
    "ꝗ":"q",
    "ŕ":"r",
    "ř":"r",
    "ŗ":"r",
    "ṙ":"r",
    "ṛ":"r",
    "ṝ":"r",
    "ȑ":"r",
    "ɾ":"r",
    "ᵳ":"r",
    "ȓ":"r",
    "ṟ":"r",
    "ɼ":"r",
    "ᵲ":"r",
    "ᶉ":"r",
    "ɍ":"r",
    "ɽ":"r",
    "ↄ":"c",
    "ꜿ":"c",
    "ɘ":"e",
    "ɿ":"r",
    "ś":"s",
    "ṥ":"s",
    "š":"s",
    "ṧ":"s",
    "ş":"s",
    "ŝ":"s",
    "ș":"s",
    "ṡ":"s",
    "ṣ":"s",
    "ṩ":"s",
    "ʂ":"s",
    "ᵴ":"s",
    "ᶊ":"s",
    "ȿ":"s",
    "ɡ":"g",
    "ᴑ":"o",
    "ᴓ":"o",
    "ᴝ":"u",
    "ť":"t",
    "ţ":"t",
    "ṱ":"t",
    "ț":"t",
    "ȶ":"t",
    "ẗ":"t",
    "ⱦ":"t",
    "ṫ":"t",
    "ṭ":"t",
    "ƭ":"t",
    "ṯ":"t",
    "ᵵ":"t",
    "ƫ":"t",
    "ʈ":"t",
    "ŧ":"t",
    "ᵺ":"th",
    "ɐ":"a",
    "ᴂ":"ae",
    "ǝ":"e",
    "ᵷ":"g",
    "ɥ":"h",
    "ʮ":"h",
    "ʯ":"h",
    "ᴉ":"i",
    "ʞ":"k",
    "ꞁ":"l",
    "ɯ":"m",
    "ɰ":"m",
    "ᴔ":"oe",
    "ɹ":"r",
    "ɻ":"r",
    "ɺ":"r",
    "ⱹ":"r",
    "ʇ":"t",
    "ʌ":"v",
    "ʍ":"w",
    "ʎ":"y",
    "ꜩ":"tz",
    "ú":"u",
    "ŭ":"u",
    "ǔ":"u",
    "û":"u",
    "ṷ":"u",
    "ü":"u",
    "ǘ":"u",
    "ǚ":"u",
    "ǜ":"u",
    "ǖ":"u",
    "ṳ":"u",
    "ụ":"u",
    "ű":"u",
    "ȕ":"u",
    "ù":"u",
    "ủ":"u",
    "ư":"u",
    "ứ":"u",
    "ự":"u",
    "ừ":"u",
    "ử":"u",
    "ữ":"u",
    "ȗ":"u",
    "ū":"u",
    "ṻ":"u",
    "ų":"u",
    "ᶙ":"u",
    "ů":"u",
    "ũ":"u",
    "ṹ":"u",
    "ṵ":"u",
    "ᵫ":"ue",
    "ꝸ":"um",
    "ⱴ":"v",
    "ꝟ":"v",
    "ṿ":"v",
    "ʋ":"v",
    "ᶌ":"v",
    "ⱱ":"v",
    "ṽ":"v",
    "ꝡ":"vy",
    "ẃ":"w",
    "ŵ":"w",
    "ẅ":"w",
    "ẇ":"w",
    "ẉ":"w",
    "ẁ":"w",
    "ⱳ":"w",
    "ẘ":"w",
    "ẍ":"x",
    "ẋ":"x",
    "ᶍ":"x",
    "ý":"y",
    "ŷ":"y",
    "ÿ":"y",
    "ẏ":"y",
    "ỵ":"y",
    "ỳ":"y",
    "ƴ":"y",
    "ỷ":"y",
    "ỿ":"y",
    "ȳ":"y",
    "ẙ":"y",
    "ɏ":"y",
    "ỹ":"y",
    "ź":"z",
    "ž":"z",
    "ẑ":"z",
    "ʑ":"z",
    "ⱬ":"z",
    "ż":"z",
    "ẓ":"z",
    "ȥ":"z",
    "ẕ":"z",
    "ᵶ":"z",
    "ᶎ":"z",
    "ʐ":"z",
    "ƶ":"z",
    "ɀ":"z",
    "ﬀ":"ff",
    "ﬃ":"ffi",
    "ﬄ":"ffl",
    "ﬁ":"fi",
    "ﬂ":"fl",
    "ĳ":"ij",
    "œ":"oe",
    "ﬆ":"st",
    "ₐ":"a",
    "ₑ":"e",
    "ᵢ":"i",
    "ⱼ":"j",
    "ₒ":"o",
    "ᵣ":"r",
    "ᵤ":"u",
    "ᵥ":"v",
    "ₓ":"x"
};
String.prototype.latinise = function(){
    return this.replace(/[^A-Za-z0-9\[\] ]/g,function(a){
        return Latinise.latin_map[a]||a;
    });
};
String.prototype.latinize = String.prototype.latinise;
String.prototype.isLatin = function(){
    return this===this.latinise();
};
